// Configuration for different environments
const config = {
  development: {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8080',
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LdHKYYsAAAAAPvkC8Yzj7yKbJek9KmV3OCr8smP',
  },
  production: {
    apiUrl: process.env.REACT_APP_API_URL || 'https://api.alpsepics.com',
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LdHKYYsAAAAAPvkC8Yzj7yKbJek9KmV3OCr8smP',
  }
};

// Get current environment
const isDevelopment = process.env.NODE_ENV === 'development';
const currentConfig = isDevelopment ? config.development : config.production;

export const API_BASE_URL = currentConfig.apiUrl;
export const RECAPTCHA_SITE_KEY = currentConfig.recaptchaSiteKey; 